/**
 * Compatibility shim over `types/messages/*`.
 *
 * Every name below kept its original identity so the split into per-type
 * modules stayed invisible to callers. This file is scheduled for deletion
 * once importers point at `types/messages/*` directly — add new exports there,
 * not here.
 */

export { MESSAGE_DATA_TYPES } from '@/types/messages/discriminators';

export {
  referenceDataSchema,
  payloadSchema as referenceMessageDataSchema,
  createReferenceMessageData,
} from '@/types/messages/reference';
export type { ReferenceData, ReferenceMessageData } from '@/types/messages/reference';

export { payloadSchema as answerMessageDataSchema } from '@/types/messages/answer';
export type { AnswerMessageData } from '@/types/messages/answer';

export {
  payloadSchema as primumSupportMessageDataSchema,
  createPrimumSupportMessageData,
} from '@/types/messages/primumSupport';
export type { PrimumSupportMessageData } from '@/types/messages/primumSupport';

export {
  payloadSchema as expertRelayMessageDataSchema,
  createExpertRelayMessageData,
} from '@/types/messages/expertRelay';
export type { ExpertRelayMessageData } from '@/types/messages/expertRelay';

export {
  payloadSchema as modInquiryMessageDataSchema,
  createMODInquiryMessageData,
} from '@/types/messages/modInquiry';
export type { MODInquiryMessageData } from '@/types/messages/modInquiry';

export {
  payloadSchema as mentorInquiryMessageDataSchema,
  createMentorInquiryMessageData,
} from '@/types/messages/mentorInquiry';
export type { MentorInquiryMessageData } from '@/types/messages/mentorInquiry';

export {
  contentCardSchema,
  payloadSchema as contentSuggestionMessageDataSchema,
} from '@/types/messages/contentSuggestion';
export type { ContentCard, ContentSuggestionMessageData } from '@/types/messages/contentSuggestion';

export { messageDataSchema } from '@/types/messages/catalog';
export type { MessageData } from '@/types/messages/catalog';
